// extracted by mini-css-extract-plugin
export var circle = "_3x-2";
export var icon = "_3x-a";
export var iconHighlight = "_3x-0";
export var lg = "_3x-8";
export var md = "_3x-7";
export var outline = "_3x-4";
export var sm = "_3x-6";
export var square = "_3x-1";
export var xl = "_3x-9";
export var xs = "_3x-5";
export var xxs = "_3x-3";